var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.action.class,attrs:{"loading":_vm.loading,"dark":_vm.dark,"light":_vm.light},on:{"click":_vm.run}},[_vm._v("\n  "+_vm._s(_vm.action.caption)+"\n\n  "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"dark":_vm.dark,"light":_vm.light}},[_vm._v("cached")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }